<template>
  <!-- Layout 1:1 cu legacy SAL_IntroduceriForm: split master-detail.
       Stânga = bară unelte + grid angajați. Dreapta = introducerile angajatului selectat. -->
  <div class="ad-split">
    <div class="ad-left">
      <PER_ActiveEmployees @selection-changed="handleSelectionChanged" />
    </div>
    <div class="ad-right">
      <div class="ad-right-title">
        Introduceri —
        <span v-if="selectedMode === 'Companie'">Companie ({{ selectedLuna }}/{{ selectedAnul }})</span>
        <span v-else-if="selectedMode === 'Valori implicite'">Valori implicite ({{ selectedLuna }}/{{ selectedAnul }})</span>
        <span v-else-if="selectedEmpId">angajat selectat</span>
        <span v-else>selectați un angajat</span>
      </div>
      <ValoriParametriiSalarizare
        class="ad-right-grid"
        :empId="selectedEmpId"
        :mode="selectedMode"
        :luna="selectedLuna"
        :anul="selectedAnul"
        :vezi-automat="selectedVeziAutomat"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import PER_ActiveEmployees from './PER_ActiveEmployees.vue';
import ValoriParametriiSalarizare from './ValoriParametriiSalarizare.vue';

export default defineComponent({
  components: {
    PER_ActiveEmployees,
    ValoriParametriiSalarizare,
  },
  data() {
    return {
      selectedEmpId: null as string | null,
      // Același default ca `modPreluare` din PER_ActiveEmployees.
      selectedMode: 'Angajati' as 'Angajati' | 'Companie' | 'Valori implicite',
      selectedLuna: new Date().getMonth() + 1,
      selectedAnul: new Date().getFullYear(),
      // false = doar manuale (implicit) · true = doar automate · null = toate.
      selectedVeziAutomat: false as boolean | null,
    };
  },
  methods: {
    handleSelectionChanged(payload: any) {
      this.selectedEmpId = payload?.empId ?? null;
      if (payload?.mode) this.selectedMode = payload.mode;
      if (payload?.luna) this.selectedLuna = payload.luna;
      if (payload?.anul) this.selectedAnul = payload.anul;
      if (payload && 'veziAutomat' in payload) this.selectedVeziAutomat = payload.veziAutomat;
    },
  },
});
</script>

<style scoped>
.ad-split {
  display: flex;
  flex-direction: row;
  height: 100vh;
  width: 100%;
  box-sizing: border-box;
  gap: 8px;
  padding: 8px;
  background: #f2f4f7;
}
.ad-left {
  flex: 0 0 46%;
  min-width: 0;
  height: 100%;
}
.ad-right {
  flex: 1;
  min-width: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
  border: 1px solid #c7cdd5;
  border-radius: 4px;
  padding: 8px;
  box-sizing: border-box;
}
.ad-right-title {
  font-size: 13px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 8px;
}
.ad-right-grid {
  flex: 1;
  min-height: 0;
}
</style>
